import type { ReactNode } from 'react';

interface StatCardProps {
  rotulo: string;
  valor: ReactNode;
  /** Texto pequeno abaixo do número (ex.: "12 aparelhos"). */
  nota?: ReactNode;
  /** Variante de destaque: fundo azul, texto branco. */
  destaque?: boolean;
  icone?: string;
  className?: string;
}

// Cartão de número: rótulo pequeno em cima, número grande embaixo.
export default function StatCard({
  rotulo,
  valor,
  nota,
  destaque = false,
  icone,
  className = '',
}: StatCardProps) {
  return (
    <div
      className={`rounded-[18px] p-4 ${
        destaque ? 'bg-primary-500 text-white' : 'bg-background-50 text-foreground-950 shadow-pcard'
      } ${className}`}
    >
      <div className="flex items-center gap-1.5">
        {icone && (
          <span
            className={`flex h-4 w-4 items-center justify-center ${destaque ? 'text-white/80' : 'text-foreground-400'}`}
          >
            <i className={icone} aria-hidden />
          </span>
        )}
        <span
          className={`text-xs font-semibold ${destaque ? 'text-white/80' : 'text-foreground-500'}`}
        >
          {rotulo}
        </span>
      </div>
      <p
        className={`mt-1.5 whitespace-nowrap font-extrabold leading-none tabular-nums ${
          destaque ? 'text-white' : 'text-foreground-950'
        }`}
        style={{ fontSize: 'clamp(20px, 6vw, 30px)' }}
      >
        {valor}
      </p>
      {nota && (
        <p className={`mt-1.5 text-xs ${destaque ? 'text-white/75' : 'text-foreground-500'}`}>
          {nota}
        </p>
      )}
    </div>
  );
}